import {ITagButton} from "@/types";
import {del, get, post} from "@/utils/Request";
import {defineStore} from "pinia";

export type submitType = 0 | 1;

export interface ITags {
  generalTags?: GeneralTag[];
  customTags?: string[];
}

export interface GeneralTag {
  name?: string;
  id?: string;
  tags?: string[];
}

export interface IDivinationResponse {
  questionId?: number;
  articleId?: number;
  subject?: string;
  calculateDate?: string;
  guaName?: string;
  guaYi?: string;
  guaImageSrc?: string;
  sex?: string;
  bazi?: string;
  mobile?: string;
  type?: string;
  divinationType?: string;
}

export interface IDivinationParams {
  subject?: string;
  tags?: ITags;
  submitType: submitType;
  remark?: string;
}

export interface IDivinationParamsForRandom extends IDivinationParams {
}

export interface IDivinationParamsForBirthday extends IDivinationParams {
  name?: string;
  sex?: string | number;
  birthplace?: string;
  birthday?: Date | string;
  isChineseBirthday?: boolean;
  isLeapMonth?: boolean;
}

export interface IDivinationParamsForMobile extends IDivinationParams {
  mobile?: string;
  sex?: string;
}

export type paramsKeys = keyof (IDivinationParams & IDivinationParamsForRandom & IDivinationParamsForBirthday & IDivinationParamsForMobile)

export interface IChooseTag {
  tag: string;
  id?: number | string;
  name?: string;
  type: number;
}

export interface ICalendarToday {
  year?: number;
  month?: number;
  day?: number;
  weekDay?: number;
  weekDayString?: string;
  holiday?: string;
  date?: Date;
  dateString?: Date;
  chineseDay?: number;
  chineseDayString?: string;
  chineseMonth?: number;
  chineseMonthString?: string;
  chineseYear?: number;
  chineseYearString?: string;
  chineseDateString?: string;
  chineseHoliday?: string;
  ganZhiYear?: string;
  ganZhiYearString?: string;
  ganZhiMonth?: string;
  ganZhiMonthString?: string;
  ganZhiDay?: string;
  ganZhiDayString?: string;
  ganZhiDateString?: string;
  ganZhiHour?: string;
  ganZhiHourString?: string;
  solarTermPrevDay?: string;
  solarTermNextDay?: string;
  constellation?: string;
  animalYear?: string;
  daJianYear?: string;
  daJianMonth?: string;
  daJianDay?: string;
  daJianHour?: string;
}


export interface IYingQiParams {
  questionId?: number;
  guaName?: string;
  scope?: string;
  baseTime?: string;
  groupby?: string;
}

export interface LuckyList {
  weiGua?: string;
  lieGua?: string;
  beginTime?: string;
  endTime?: string;
  ageDescription?: string;
  isCurrentScope?: boolean;
  isDynamicPosition?: boolean;
  smallLuckyList?: LuckyList[];
}

export interface IOrderParams {
  questionId: number,
  orderType: number
}

export interface IOrderResponse {
  orderId?: number;
  questionId?: number;
  orderNo?: string;
  wxpayQequestData?: WxpayQequestData;
}


export interface IJsApiConfigRequestData {
  url: string
}

export interface IJsApiConfigResponseData {
  appId: string,
  timestamp: number,
  nonceStr: string,
  signature: string,
  jsApiList: Array<string>
}

export interface WxpayQequestData {
  appId?: string;
  timeStamp?: string;
  nonceStr?: string;
  package?: string;
  signType?: string;
  paySign?: string;
}

export interface IQuestionAIResultResponse {
  questionId?: number;
  subject?: string;
  answers?: Answer[];
}

export interface Answer {
  categoryId?: number;
  categoryName?: string;
  categoryDescription?: string;
  answerContent?: string;
  icon?: string;
}

export interface IAiResultMark {
  questionId?: number;
  score?: number;
  questionType?: 0 | 1;
  comment?: string;
}

export interface IQuestionAnalyseParams {
  articleId?: number;
  questionId?: number;
  isPublic?: boolean;
  analyseContent?: string;
  summary?: string;
}

export interface IBaseAddress {
  value: number;
  text: string;
}

export interface IAddress extends IBaseAddress {
  children?: IAddress[] | IBaseAddress[]
}

export const tags: ITagButton[] = [
  {
    text: "感应定卦",
  },
  {
    text: "八字",
  },
  {
    text: "手机号码",
  },
];

export default defineStore("home", {
  state: () => ({
    tags: {
      generalTags: [],
      customTags: [],
    } as ITags,
    todayInfo: {} as ICalendarToday,
    remark: '',
    resultReloadId: '' as string | number
  }),
  getters: {},
  actions: {
    setResultReloadId(value: string | number) {
      this.resultReloadId = value
    },
    setRemark(value: string) {
      this.remark = value
    },
    async getTags() {
      this.tags = await get<ITags>("/h5/tag");
    },
    async divinationByRandom(params: IDivinationParamsForRandom) {
      return await post<IDivinationResponse>(`h5/divination/${params.submitType}/random`, params)
    },
    async divinationByBirthday(params: IDivinationParamsForBirthday) {
      return await post<IDivinationResponse>(
        `h5/divination/${params.submitType}/byBirthday`,
        params
      );
    },
    async divinationByMobile(params: IDivinationParamsForMobile) {
      return await post<IDivinationResponse>(
        `h5/divination/${params.submitType}/byMobile`,
        params
      );
    },
    async divination(type: string, params: string) {
      const formData = JSON.parse(params)
      let res: IDivinationResponse | null = null;
      if (type === '0') {
        res = await this.divinationByRandom(formData)
      } else if (type === '1') {
        res = await this.divinationByBirthday(formData)
      } else if (type === '2') {
        res = await this.divinationByMobile(formData)
      }
      return res;
    },
    async divinationYingQi(params: IYingQiParams) {
      return await get<{ questionId: number, bigLuckyList: LuckyList[] }>(
        'h5/divination/yingqi',
        params
      )
    },
    async calendarToday() {
      const res = await get<{ today: ICalendarToday }>("/h5/calendar/today");
      this.todayInfo = res.today;
    },
    async order(params: IOrderParams) {
      return await post<IOrderResponse>('h5/order', params)
    },
    async getJsApiConfig(params: IJsApiConfigRequestData) {
      return await get<IJsApiConfigResponseData>('h5/weixin/jssdk/config', params)
    },
    async orderStatus(orderNo: string) {
      return await get<{
        questionId: number,
        payStatus: "SUCCESS" | "REFUND" | "NOTPAY" | "CLOSED" | "REVOKED" | "USERPAYING" | "PAYERROR",
        orderNo: string
      }>(`h5/order/${orderNo}`)
    },
    async divinationAiQuestionAnalyse(questionId: number) {
      return await get<IQuestionAIResultResponse>(`h5/divination/AiQuestionAnalyse/${questionId}`)
    },
    async divinationAiMark(params: IAiResultMark) {
      return await post<{
        questionId: number
        successful: boolean
      }>('h5/divination/mark', params)
    },
    async questionAnalyse(params: IQuestionAnalyseParams) {
      return await post<{
        divinationArticleId: number
      }>('h5/divination/qusetionAnalyse', params)
    },
    async getAddress(value: number) {
      return await get<IAddress[]>(`h5/geo/${value}`)
    },
    async modifyArticle(params: IQuestionAnalyseParams) {
      return await post<boolean>('h5/bbs/modifyArticle', params)
    },
    async addTag(tagName: string) {
      return await post<boolean>(`h5/tag/addTag/${tagName}`)
    },
    async delTag(tagName: string) {
      return await del<boolean>(`h5/tag/delTag/${tagName}`)
    },
    async hasAnswered(questionId: number) {
      return await get<boolean>(`h5/question/hasAnswered/${questionId}`)
    },
    async discard(questionId: number) {
      return await del<boolean>(`h5/question/discard/${questionId}`)
    }
  },
});
